var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAboutStroke6 = function SvgAboutStroke6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 505,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#205287",
    strokeDasharray: "22 22",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M106.664 10.024c-9.859 0-19.806.471-29.636-2.258-4.222-1.172-8.37-4.098-12.576-5.338C54.562-.484 41.027 6.33 31.086 6.33c-6.358 0-13.64-4.714-17.697 14.37-2.495 11.736-1.089 12.247-3.271 24.838-3.207 18.505-5.816 38.288-6.97 59.531-2.507 46.177-.06 91.094 1.091 136.921.27 10.704.497 21.091.546 31.818.056 12.461 1.356 24.07 1.606 36.335.435 21.4.241 42.982.848 64.354.693 24.411-5.174 66.087 0 83.982 7.392 25.563 18.913 33.205 28.758 41.98 7.338 6.541 33.597-4.18 41.03 1.004"
  })));
};
export default SvgAboutStroke6;